export default __webpack_public_path__ + "static/media/rachel.78f36007.jpg";